<script lang="ts">
  import { setCurrentView } from '../../stores/launchpad.svelte'
</script>

<div class="LaunchpadIndex">
  <div class="flex-row launchpad-cards">

    <button class="cell-1 launchpad-card launchpad-card--have-contacts"
            onclick={() => setCurrentView('got-contacts')}>
      <span class="h2">Got Contacts?</span>
      <span class="p">
        Import your list of contacts into the system
        to start messaging.
      </span>
      <span class="btn btn-green btn-rounded btn-rounded">Get Started</span>
    </button>

    <button class="cell-1 launchpad-card launchpad-card--need-contacts"
            onclick={() => setCurrentView('got-no-contacts')}>
      <span class="h2">Need Contacts?</span>
      <span class="p">
        Learn some of the ways you can build your audience.
      </span>
      <span class="btn btn-green btn-rounded btn-rounded">Learn More</span>
    </button>

    <button class="cell-1 launchpad-card launchpad-card--auto-response"
            onclick={() => setCurrentView('auto-response')}>
      <span class="h2">Auto Responses</span>
      <span class="p">
        Offer value with a custom auto-response when
        a contact opts in.
      </span>
      <span class="btn btn-green btn-rounded btn-rounded">Learn More</span>
    </button>

    {#if false}
      <button class="cell-1 launchpad-card launchpad-card--tour" onclick={() => setCurrentView('tour')}>
        <span class="h2">Want a Tour?</span>
        <span class="p">
        Schedule a demo with one of our friendly support staff.
      </span>
        <span class="btn btn-green btn-rounded btn-rounded">Schedule</span>
      </button>
    {/if}

  </div>
</div>
